const options = {
  5: "bg-sky-600/5",
  10: "bg-sky-600/10",
  25: "bg-sky-600/25",
  50: "bg-sky-600/50",
  75: "bg-sky-600/75",
  90: "bg-sky-600/90",
  100: "bg-sky-600",
};

const from = {
  5: "from-sky-600/5",
  10: "from-sky-600/10",
  25: "from-sky-600/25",
  50: "from-sky-600/50",
  75: "from-sky-600/75",
  90: "from-sky-600/90",
  100: "from-sky-600",
};

export default function getBackgroundSky600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
